import { useTranslation } from "react-i18next";
import { Select } from "ui";

import { useDriversList } from "../../hooks";
import { DriverSelectorItem } from "./atoms";
import { DriverSelectorProps } from "./DriverSelector.types";

const DriverSelector = ({
  value,
  onChange,
  isLoading,
  additionalOptions,
  deliveryCompanyId
}: DriverSelectorProps) => {
  const { t } = useTranslation();

  const { drivers, isLoading: isLoadingDrivers } = useDriversList(
    deliveryCompanyId
      ? ({ deliveryCompanyId } as unknown as Parameters<
          typeof useDriversList
        >[0])
      : undefined
  );

  const driverList = drivers?.map((driver) => ({
    label: (
      <DriverSelectorItem
        image={driver.image}
        name={`${driver.firstname} ${driver.lastname}`}
      />
    ),
    value: driver.id
  }));

  const allDrivers = [
    ...(additionalOptions?.length ? additionalOptions : []),
    ...(driverList?.length ? driverList : [])
  ];

  return (
    <Select
      placeholder={t("Choose Driver")}
      value={value}
      onChange={onChange}
      options={allDrivers ?? []}
      isOptionsLoading={isLoading ?? isLoadingDrivers}
    />
  );
};

export default DriverSelector;
